<template>
  <div style="height: 100%">
    <div v-if="columnSettingsKey || $slots.toolbar" class="table-toolbar">
      <span class="table-toolbar-left">
        <slot name="toolbar"></slot>
      </span>
      <span v-if="columnSettingsKey" class="table-toolbar-right">
        <a-icon
          type="setting"
          class="table-column-settings-icon"
          @click="openColumnSettings"
        />
      </span>
    </div>
    <a-table
      :ellipsis="true"
      :loading="loading"
      :row-selection="
        isSelect
          ? {
              type: 'radio',
              selectedRowKeys: selectedRowKeys,
              selectedRows: selectedRows,
              onChange: onSelectChange,
            }
          : null
      "
      :columns="displayColumns"
      :customRender="customRender"
      :data-source="tableData"
      bordered
      :rowKey="(record, index) => index"
      size="small"
      :customRow="onClickRow"
      :pagination="pagination"
    >
      <!-- 账单日期 -->
      <template slot="fromDate" slot-scope="scope, record">
        {{ record.fromDate }} {{ $t("to") }} {{ record.toDate }}</template
      >
      <!-- 支付时间 -->
      <template slot="paymentTime" slot-scope="scope">
        {{ scope ? scope.slice("", 10) : "" }}
      </template>
      <!-- 开票时间 -->
      <template slot="billingTime" slot-scope="scope">
        {{ scope ? scope.slice("", 10) : "" }}
      </template>
      <!-- 应收费用 -->
      <template slot="receivableAmount" slot-scope="scope, record">
        <div style="text-align: right;">
          <AmountText :value="scope" :currency="record.currency" />
          <span v-if="record.paymentTime != null" style="color: blue; font-weight: 800"
            >✔</span
          >
        </div>
      </template>
      <!-- 发票号 -->
      <template slot="invoiceNumber" slot-scope="scope, record">
        <!-- {{ scope}}{{record.invoiceNumber}} -->
        <a-tooltip
          :title="record.invoiceNumber"
          placement="bottom"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <span class="popovername">{{ record ? record.invoiceNumber : "" }}</span>
        </a-tooltip>
      </template>
      <!-- 发票备注 -->
      <template slot="invoiceRemark" slot-scope="scope, record">
        <!-- {{ scope}}{{record.invoiceNumber}} -->
        <a-tooltip
          :title="record.invoiceRemark"
          placement="bottom"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <span class="popovername">{{ record ? record.invoiceRemark : "" }}</span>
        </a-tooltip>
      </template>
    </a-table>
    <a-modal
      :visible="columnSettingsVisible"
      :title="$t('columnSettings.title')"
      :width="480"
      :mask-closable="false"
      :body-style="{ maxHeight: '60vh', overflowY: 'auto', paddingRight: '16px' }"
      @cancel="closeColumnSettings"
    >
      <draggable
        :list="editingItems"
        :animation="150"
        item-key="key"
      >
        <div
          v-for="item in editingItems"
          :key="item.key"
          class="column-settings-row"
          :class="{ 'row-hidden': item.hidden }"
        >
          <a-checkbox
            :checked="!item.hidden"
            @change="(e) => onToggleColumn(item.key, e.target.checked)"
          >
            {{ item.title }}
          </a-checkbox>
        </div>
      </draggable>
      <template slot="footer">
        <a-button @click="closeColumnSettings">{{ $t('columnSettings.cancel') }}</a-button>
        <a-button type="primary" @click="saveColumnSettings">{{ $t('columnSettings.ok') }}</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import AmountText from "../../../components/AmountText.vue";
import {
  getColumnSettings,
  setColumnSettings,
  mergeColumns,
} from "@/utils/column-settings";
export default {
  name: "table-fixed",
  components: {
    AmountText,
    draggable,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    tableColumn: {
      type: Array,
      default() {
        return [];
      },
    },
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    isSelect: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Object,
      default() {
        return {};
      },
    },
    columnSettingsKey: {
      type: String,
      default: "",
    },
    lockedColumnKeys: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      selectedRowKeys: [],
      selectedRows: [],
      columnSettingsVisible: false,
      editingItems: [],
      settingsVersion: 0,
    };
  },
  computed: {
    displayColumns() {
      // eslint-disable-next-line no-unused-vars
      const _v = this.settingsVersion;
      const settings = getColumnSettings(this.columnSettingsKey);
      return mergeColumns(this.tableColumn, settings, this.lockedColumnKeys);
    },
  },
  watch: {
    tableData() {
      console.log(
        "this.tableData is changed === ",
        this.tableData,
        this.selectedRowKeys,
        this.selectedRows
      );
      this.selectedRowKeys = [];
      this.selectedRows = [];
      // 通知父单元情况选择数据
      this.selectChanged([]);
    },
  },
  created() {},
  methods: {
    onSelectChange(selectedRowKeys, selectedRows) {
      console.log("selectedRowKeys changed: ", selectedRowKeys, selectedRows);
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
      this.selectChanged(selectedRows);
    },
    // 点击一行实现选中
    onClickRow(record, index) {
      return {
        on: {
          click: () => {
            console.log("行事件", record, index);
            this.selectedRowKeys = [index];
            this.selectedRows = [record];
            this.selectChanged(this.selectedRows);
          },
          dblclick: () => {
            console.log("双击此行", record, index);
            this.selectedRowKeys = [index];
            this.selectedRows = [record];
            this.$emit("dbclickRow", this.selectedRows);
          },
          mouseenter: () => {
            this.rowClassName;
          }, // 鼠标移入行
        },
      };
    },
    // 通知父单元选择项发生变化
    selectChanged(selectedRows) {
      this.$emit("onSelectChange", selectedRows);
    },
    customRender(text, record, index) {
      console.log(text, record, index);
    },
    columnKeyOf(c) {
      if (c && typeof c.dataIndex === "string" && c.dataIndex !== "") return c.dataIndex;
      if (c && typeof c.title === "string" && c.title !== "") return c.title;
      return null;
    },
    columnTitleOf(c) {
      if (!c) return "";
      if (typeof c.title === "string") return c.title;
      return c.dataIndex || "";
    },
    buildEditingItems() {
      const settings = getColumnSettings(this.columnSettingsKey);
      const hiddenSet = new Set(settings.hidden);
      const lockedSet = new Set(this.lockedColumnKeys);
      const configurableCols = this.tableColumn.filter((c) => {
        const k = this.columnKeyOf(c);
        return k !== null && !lockedSet.has(k);
      });
      const order = settings.order && settings.order.length > 0
        ? settings.order
        : configurableCols.map((c) => this.columnKeyOf(c));
      const keyToCol = new Map();
      configurableCols.forEach((c) => {
        const k = this.columnKeyOf(c);
        if (k !== null) keyToCol.set(k, c);
      });
      const seen = new Set();
      const items = [];
      order.forEach((k) => {
        if (keyToCol.has(k) && !seen.has(k)) {
          seen.add(k);
          items.push({
            key: k,
            title: this.columnTitleOf(keyToCol.get(k)),
            hidden: hiddenSet.has(k),
          });
        }
      });
      configurableCols.forEach((c) => {
        const k = this.columnKeyOf(c);
        if (k !== null && !seen.has(k)) {
          seen.add(k);
          items.push({
            key: k,
            title: this.columnTitleOf(c),
            hidden: hiddenSet.has(k),
          });
        }
      });
      return items;
    },
    openColumnSettings() {
      this.editingItems = this.buildEditingItems();
      this.columnSettingsVisible = true;
    },
    closeColumnSettings() {
      this.columnSettingsVisible = false;
      this.editingItems = [];
    },
    onToggleColumn(key, checked) {
      const item = this.editingItems.find((i) => i.key === key);
      if (item) this.$set(item, "hidden", !checked);
    },
    saveColumnSettings() {
      setColumnSettings(this.columnSettingsKey, {
        order: this.editingItems.map((i) => i.key),
        hidden: this.editingItems.filter((i) => i.hidden).map((i) => i.key),
      });
      this.settingsVersion++;
      this.columnSettingsVisible = false;
      this.editingItems = [];
    },
  },
};
</script>
<style scoped lang="less">
.table-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  margin-bottom: 8px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}
.table-toolbar-left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.table-toolbar-right {
  display: flex;
  align-items: center;
}
.table-column-settings-icon {
  font-size: 16px;
  cursor: pointer;
  color: #888;
}
.table-column-settings-icon:hover {
  color: #1890ff;
}
.column-settings-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
  border: 1px solid #e8e8e8;
  margin-bottom: 4px;
  background: #fff;
  cursor: grab;
  user-select: none;
}
.column-settings-row:hover {
  border-color: #1890ff;
}
.column-settings-row:active {
  cursor: grabbing;
}
.column-settings-row.row-hidden {
  opacity: 0.5;
  background: #fafafa;
}
</style>
